import { z } from '@hono/zod-openapi'

// カタカナバリデーション用の正規表現（半角・全角スペース許可）
export const KATAKANA_REGEX = /^[ァ-ヶー 　]+$/

// カタカナバリデーションエラーメッセージ
export const KATAKANA_ERROR_MESSAGE = '全角カタカナで入力してください'

// 町名・丁目・番地用バリデーション（カタカナ、数字、ハイフン、スペース）
export const ADDRESS_KANA_REGEX = /^[ァ-ヴー0-9０-９\-− 　]+$/

// 町名・丁目・番地用バリデーションエラーメッセージ
export const ADDRESS_KANA_ERROR_MESSAGE =
  'カタカナ、数字（半角・全角）、ハイフン（半角・全角）で入力してください'

// カタカナのみを許可するzodスキーマ（最小1文字）
export const katakanaZ = z
  .string()
  .min(1)
  .regex(KATAKANA_REGEX, KATAKANA_ERROR_MESSAGE)

// カタカナのみを許可するzodスキーマ（optional: 空値許可、入力時はカタカナのみ）
export const katakanaOptionalZ = z
  .string()
  .optional()
  .refine((val) => !val || KATAKANA_REGEX.test(val), {
    message: KATAKANA_ERROR_MESSAGE,
  })

// 半角英数字バリデーション用の正規表現
export const ALPHANUMERIC_REGEX = /^[0-9A-Za-z]+$/

// 半角英数字バリデーションエラーメッセージ
export const ALPHANUMERIC_ERROR_MESSAGE = '半角英数字で入力してください'

// 半角英数字のみを許可するzodスキーマ（最小1文字）
export const alphanumericZ = z
  .string()
  .min(1)
  .regex(ALPHANUMERIC_REGEX, ALPHANUMERIC_ERROR_MESSAGE)
